import React, { useState } from "react";

import { ManualImport, Wizard, WondeImport } from "./";
import { styles } from "../SchoolAdminStyles";
import { LoadingSpinner } from "../../Shared";

import "../../../assets/stlyes/SchoolAdminPupilImport.css";

const PupilImport = (props) => {
  const { setFullScreen } = props;
  const [isLoading, setIsLoading] = useState(false);
  
  return (
    <>{isLoading ? <LoadingSpinner /> :
      <div style={{ paddingRight: setFullScreen() }}>
        <div style={styles.importStyle} className="second-div-pupil-import">
          <WondeImport setIsLoading={setIsLoading}/>
          <ManualImport setIsLoading={setIsLoading}/>
          {false && <Wizard />}
        </div>
      </div>}</>
  )
}

export { PupilImport };
